import { observer } from 'mobx-react';
import { FC } from 'react';
import ImageBlock from '../../../../containers/ImageBlock/ImageBlock';
import configKioskStore from '../../store';
import { IConfigKioskImages } from '../../types';
import './style.scss';

const KioskConfigImagesTab: FC = observer((): JSX.Element => {
  const { bannerImage } = configKioskStore.images;

  const uploadImage = (field: keyof IConfigKioskImages) => (file: string) => {
    configKioskStore.changeImages({ [field]: file });
  };

  return (
    <div className="d-flex flex-column flex-1 full-width mt-4 pr-4">
      <ImageBlock
        type="kiosk_screen_image"
        title="banner"
        image={bannerImage}
        uploadImage={uploadImage('bannerImage')}
        validation={configKioskStore.imagesValidation.bannerImage}
        required
        maxSize={2097152} // 2mb
        maxResolution="1500x2666 px"
        className="kiosk-config-images-block__image-block"
        uploadWrapperClassName="kiosk-config-images-block__upload-wrapper"
      />
    </div>
  );
});

export default KioskConfigImagesTab;
